// extracted by mini-css-extract-plugin
export default {"root":"IconItems_root__WCyqb"};